function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_7135",
  "data-name": "Group 7135",
  transform: "translate(36 35.958) rotate(180)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_7134",
  "data-name": "Group 7134"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5537",
  "data-name": "Rectangle 5537",
  width: 36,
  height: 36,
  transform: "translate(0 -0.042)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_7132",
  "data-name": "Group 7132",
  transform: "translate(11.026 11.556)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3838",
  "data-name": "Path 3838",
  d: "M201.906,616.214l3.252,3.252,2.283-2.283L200.258,610l-2.283,2.283.035.035-4.866,4.865,2.283,2.283,3.252-3.252V626.3h3.229Z",
  transform: "translate(-193.143 -610)",
  fill: "#f37320"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_7133",
  "data-name": "Group 7133",
  transform: "translate(6.875 6.874)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3839",
  "data-name": "Path 3839",
  d: "M188,631v4.036h2.422v-1.614h17.758v1.614H210.6V631Z",
  transform: "translate(-188 -631)",
  fill: "#f37320"
}))));

function SvgDownloadFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFile);
export default __webpack_public_path__ + "static/media/downloadFile.bbd05041ed9cfcf5e0427a8d32197227.svg";
export { ForwardRef as ReactComponent };